<div class="hm-card">
  <div class="hm-card-body">
    @if (feedFilterState.categoryLabel) {
    <div class="hm-filter-banner">
      <span class="hm-filter-banner-text">
        Лента по статусам: <strong>{{ feedFilterState.categoryLabel }}</strong>
      </span>
      <button type="button" class="hm-filter-banner-clear" (click)="clearWelcomeFeedFilter()">
        Сбросить
      </button>
    </div>
    }

    <div class="hm-tabs-wrapper">
      <ui-tabs
        [activeValue]="activeTab"
        (activeValueChange)="onSelectTab($event)"
        [tabs]="[
          { label: 'Все',          value: 'all' },
          { label: 'Идеи',         value: 'ideas' },
          { label: 'Комментарии',  value: 'comments' },
          { label: 'Решения',      value: 'decisions' }
        ]"
      ></ui-tabs>
    </div>
  </div>

  <div class="hm-feed-content">
    @if (entities?.length) {
    <div class="hm-feed-wrapper">
      <div class="hm-rail"></div>
      @for (row of entities; track row; let i = $index) {
      @if (showDayHeader(i)) {
      <div class="hm-date__wrapper">
        <h3 class="hm-date" pTooltip="{{row.Created | date: 'dd.MM.yyyy - HH:mm'}}">
          {{ getDayLabel(row.Created) }}
        </h3>
        <div class="hm-date-divider"></div>
      </div>
      }

      @if (!isCardEvent(row)) {
      <!-- Event Row -->
      <div class="hm-event-row hm-feed-row">
        <div class="hm-event-dot" [ngClass]="'tone-' + getEventTone(row)"
          [style.border-color]="getEventTypeDisplayColor(row) || null"></div>
        <span class="hm-event-icon" [style.background]="eventTypeChipBackground(row)"
          [style.color]="eventTypeChipColor(row) || '#5d6679'">
          <i [class]="getEventTypeIconClass(row)" aria-hidden="true"></i>
        </span>
        <span class="hm-event-text" [innerHTML]="getEventDescriptionNoDot(row, false)"></span>
        <div class="hm-spacer"></div>
        <span class="hm-time-badge">
          {{ row.Created | date: "HH:mm" : "" : "ru-RU" }}
        </span>
      </div>
      }

      @if (isCardEvent(row)) {
      <!-- Idea Card Row -->
      <div class="hm-idea-row hm-feed-row">
        <div class="hm-row-rail"
          [style.background]="'linear-gradient(180deg, ' + (getEventTypeDisplayColor(row) || '#2F6BFF') + ' 0%, ' + (getEventTypeDisplayColor(row) || '#2F6BFF') + ' 100%)'">
        </div>
        <div class="hm-idea-dot" [style.border]="'2px solid ' + (getEventTypeDisplayColor(row) || '#2F6BFF')"
          [style.box-shadow]="'0 0 0 4px ' + (getEventTypeDisplayColor(row) || '#2F6BFF') + '22'"></div>
        <article class="hm-idea-card">
          <div class="hm-idea-card-content">
            <!-- Author info -->
            <div class="hm-author-info">
              <div class="hm-author-avatar" [style.background]="getUserAvatarUrl(row) ? 'transparent' : '#f1f4f9'">
                @if (getUserAvatarUrl(row); as photoUrl) {
                <img [src]="photoUrl" class="hm-author-avatar-img" alt="Аватар" loading="lazy" />
                } @else {
                <i class="fas fa-user-tie hm-author-avatar-icon"></i>
                }
              </div>
              <div class="hm-author-details">
                <div class="hm-meta-info">
                  <span class="hm-idea-number">
                    @if (!isCommentEvent(row)) {
                    Идея №{{ row.IdeaId }} была добавлена
                    } @else {
                    прокомментировал идею №{{ row.IdeaId }}
                    }

                  </span>

                  
                </div>
                
              </div>
              <div class="status-pill">
                <div
                  class="status-pill__inner"
                  [style.background]="
                    getIdeaStatus(row)?.Color || '#b3b8c6'
                  "
                >
                  <i class="fas fa-link"></i>
                  {{ getIdeaStatus(row)?.Title }}
                </div>
              </div>
              <div class="hm-spacer"></div>
              <span class="hm-time-badge">
                {{ row.Created | date: "HH:mm" : "" : "ru-RU" }}
              </span>
            </div>



            <!-- Title/Content -->
            <p class='hm-idea-card__title'>
              {{ row.Title }}
            </p>

            <!-- Footer with stats and action -->
            <div class="hm-idea-footer">
              @if (!isCommentEvent(row)) {

              <button class="hm-idea-action-btn">
                <i class="far fa-thumbs-up" aria-hidden="true"></i> {{ getIdeaStatLikes(row) }}
              </button>
              <button class="hm-idea-action-btn">
                <i class="fas fa-eye" aria-hidden="true"></i> {{ getIdeaStatViews(row) }}
              </button>
              <button class="hm-idea-action-btn">
                <i class="fas fa-comment" aria-hidden="true"></i> {{ getIdeaStatComments(row) }}
              </button>
              }

              <div class="hm-spacer"></div>
              <a class="hm-idea-open-btn" [routerLink]="['/idea-v2/', row.IdeaId]">
                Открыть
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"
                  strokeLinecap="round">
                  <path d="M9 6l6 6-6 6"></path>
                </svg>
              </a>
            </div>
          </div>
        </article>
      </div>
      }
      }
    </div>

    @if (!isLastPage) {
    <div class="hm-load-more-wrapper">
      <button type="button" class="hm-load-more-btn" (click)="loadNextPage()">
        Показать ещё события
      </button>
    </div>
    }
    } @else {
    <div class="hm-empty-state">
      <i class="fas fa-inbox hm-empty-state-icon"></i>
      <p>{{ getEmptyStateMessage() }}</p>
    </div>
    }
  </div>
</div>

<app-loading-ui-blocker [loading]="loading" />